import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { MmuWebComponentLoaderService } from '../loader-service/mmu-web-component-loader.service';


@Directive({
  selector: '[mmuWebComponent]'
})
export class MmuWebComponentDirective implements OnInit {

  @Input('mmuWebComponent')
  set manifestUrl(url: string) {
    this._manifestUrl = url;
  }

  get manifestUrl(): string {
    return this._manifestUrl;
  }

  get tagName(): string {
    return this._tagName;
  }

  private readonly _tagName: string;
  private _manifestUrl = '';

  constructor(
    private _loader: MmuWebComponentLoaderService,
    private _el: ElementRef
  ) {
    // Extract the host element's tag name
    this._tagName = _el?.nativeElement?.tagName?.toLocaleLowerCase();
  }

  ngOnInit(): void {
    if (!this._tagName) {
      console.error('MmuWebComponentDirective: Could not read the host element\'s tag name! Will not be able to load the '
        + 'web component script.');
      return;
    }

    if (!this._manifestUrl || this.manifestUrl === '') {
      console.error('MmuWebComponentDirective: Please provide a manifest URL for the directive to work. It needs to be bound ' +
        'directly to the directive name like [mmuWebComponent]="anything".');
      return;
    }

    this.loadWebComponentScript();
  }

  private loadWebComponentScript(): void {
    this._loader.loadScript(this._manifestUrl, this._tagName).then();
  }
}
